import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'booking-schedule',
    component: Children,

    children: [
      {
        path: '',
        component: Children,

        children: [
          {
            path: '',
            name: 'booking-schedule',
            component: () => import('../pages/BookingSchedulePage.vue')
          }
        ]
      }
    ]
  }
];

export default routes;
